import { ActionIconButton } from '../../components/ui/ActionButton';
import React from 'react';
import { useAnnualPlanTranslation } from '../../hooks/useAnnualPlanTranslation';
import { IoPencilOutline } from 'react-icons/io5';
import './monitoring.css';

export function AtpLoadComparison({ target, actual, future = false, incomplete = false, onEditTarget, targetEditor, editDisabled = false, compact = false, extraMetrics }: { target: number; actual: number | null; future?: boolean; incomplete?: boolean; onEditTarget?: () => void; targetEditor?: React.ReactNode; editDisabled?: boolean; compact?: boolean; extraMetrics?: React.ReactNode }) {
  const { t, i18n } = useAnnualPlanTranslation();
  const m = (key: string, values = {}) => t(`annualPlan.monitor.${key}`, values);
  const number = (n: number) => Math.round(n).toLocaleString(i18n.language);
  const delta = actual == null ? null : Math.round(actual) - Math.round(target);
  const scale = Math.max(1, target, actual ?? 0);
  const targetWidth = target / scale * 100;
  const actualWidth = (actual ?? 0) / scale * 100;
  return <div className={`atp-comparison${compact ? ' atp-comparison--compact' : ''}`}>
    <div className={`atp-comparison-values${extraMetrics ? ' atp-comparison-values--four' : ''}`}>
      <div><div className="atp-target-heading"><span>{m('target')}</span>{onEditTarget && !targetEditor && <ActionIconButton
        type="button"
        className="atp-target-edit"
        size="sm"
        disabled={editDisabled}
        onClick={onEditTarget}
        label={m('editTarget')}
        icon={<IoPencilOutline aria-hidden="true" />}
      />}</div>{targetEditor ?? <><strong>{number(target)}</strong><small>{t('workoutBuilder.textLabels.TSS')}</small></>}</div>
      <div><span>{m('actual')}</span><strong>{actual == null ? '—' : number(actual)}</strong><small>{t('workoutBuilder.textLabels.TSS')}</small></div>
      {extraMetrics}
    </div>
    {!compact && <><div className="atp-comparison-track" aria-hidden="true">
      <span className="atp-comparison-fill" style={{width: `${Math.min(targetWidth, actualWidth)}%`}} />
      {actualWidth > targetWidth && <span className="atp-comparison-excess" style={{insetInlineStart: `${targetWidth}%`, width: `${actualWidth-targetWidth}%`}} />}
      <span className="atp-comparison-marker" style={{insetInlineStart: `clamp(1px, ${targetWidth}%, calc(100% - 2px))`}} />
    </div>
    <div className="atp-comparison-caption"><span className={delta != null && delta > 0 ? 'atp-delta-over' : ''}>{future ? m('futureWeek') : delta == null ? '—' : m(incomplete ? 'partialActual' : delta > 0 ? 'aboveTarget' : delta < 0 ? 'belowTarget' : 'onTarget', {value: number(Math.abs(delta))})}</span><small>{m('targetMarker')}</small></div></>}
  </div>;
}
